var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 9.99995C4.99995 10.3944 5.31973 10.7142 5.71423 10.7142C6.10873 10.7142 6.42852 10.3944 6.42852 9.99995C6.42852 9.60545 6.10873 9.28566 5.71423 9.28566C5.31973 9.28566 4.99995 9.60545 4.99995 9.99995Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 9.99995C0.714233 10.3944 1.03403 10.7142 1.42852 10.7142C1.823 10.7142 2.1428 10.3944 2.1428 9.99995C2.1428 9.60545 1.823 9.28566 1.42852 9.28566C1.03403 9.28566 0.714233 9.60545 0.714233 9.99995Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 5.71423C4.99995 6.10873 5.31973 6.42852 5.71423 6.42852C6.10873 6.42852 6.42852 6.10873 6.42852 5.71423C6.42852 5.31973 6.10873 4.99995 5.71423 4.99995C5.31973 4.99995 4.99995 5.31973 4.99995 5.71423Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 5.71423C0.714233 6.10873 1.03403 6.42852 1.42852 6.42852C1.823 6.42852 2.1428 6.10873 2.1428 5.71423C2.1428 5.31973 1.823 4.99995 1.42852 4.99995C1.03403 4.99995 0.714233 5.31973 0.714233 5.71423Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 1.42852C4.99995 1.823 5.31973 2.1428 5.71423 2.1428C6.10873 2.1428 6.42852 1.823 6.42852 1.42852C6.42852 1.03403 6.10873 0.714233 5.71423 0.714233C5.31973 0.714233 4.99995 1.03403 4.99995 1.42852Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 1.42852C0.714233 1.823 1.03403 2.1428 1.42852 2.1428C1.823 2.1428 2.1428 1.823 2.1428 1.42852C2.1428 1.03403 1.823 0.714233 1.42852 0.714233C1.03403 0.714233 0.714233 1.03403 0.714233 1.42852Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.45c30e4d.svg";
export { ForwardRef as ReactComponent };